import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "banner_container" }
const _hoisted_2 = ["src"]

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Autoplay, Pagination } from 'swiper'
import { CommunityBanners } from '@/api/Models/CommunityBanners'
import { useThemeColor } from '@/utils/theme'
// import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    bannerList: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v140672a4": (_unref(themeColor))
}))


const modules = [Autoplay, Pagination]
const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}
// const router = useRouter()
const skipHandle = (linkStatus: string, appUrl: string) => {
  if (linkStatus) {
    handleExternalUrl({ jumpUrl: appUrl })
    // router.push('/webview?url=' + encodeURIComponent(appUrl))
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      modules: modules,
      centeredSlides: true,
      loop: "",
      class: _normalizeClass(["banner_wrapper", 'banner_wrapper_full']),
      pagination: pagination
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bannerList, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index,
            onClick: ($event: any) => (skipHandle(item.linkStatus, item.appUrl))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.imgUrl,
                class: "banner_img"
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})